// src/components/common/icons/VerifiedFireBadge.tsx

"use client";

import React from "react";
import { FireIcon } from "../../../components/icons";
import "./VerifiedBadge.css";

interface VerifiedFireBadgeProps {
  size?: "sm" | "md";
  tooltip?: boolean;
}

const VerifiedFireBadge: React.FC<VerifiedFireBadgeProps> = ({
  size = "sm",
  tooltip = true,
}) => {
  return (
    <div className={`verified-fire-badge verified-fire-badge--${size}`}>
      {tooltip ? (
        <div className="verified-fire-badge__tooltip-wrapper">
          <FireIcon className="verified-fire-badge__icon" />
          <span className="verified-fire-badge__tooltip">
            Verified by TownLIT – Spirit-Filled & Set Apart 🔥
          </span>
        </div>
      ) : (
        <FireIcon className="verified-fire-badge__icon" />
      )}
    </div>
  );
};

export default VerifiedFireBadge; 
